import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const getRequestExpensesCategories = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/requestExpenses/categories`,
    dispatch,
  });
  if (response) return response.data;
};

export const updateRequestExpensesCategory = async (
  dispatch: Dispatch,
  id: number,
  data: { name: string; hasIva: boolean },
) => {
  const response = await requestHandler({
    method: 'put',
    url: `internal/requestExpenses/categories/${id}`,
    data,
    dispatch,
  });
  return response;
};

export const deleteRequestExpensesCategory = async (
  dispatch: Dispatch,
  id: number,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/requestExpenses/categories/${id}`,
    dispatch,
  });
  return response;
};

export const createRequestExpensesCategory = async (
  dispatch: Dispatch,
  data: { name: string; hasIva: boolean },
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/requestExpenses/categories`,
    data,
    dispatch,
  });
  return response;
};
